import { useCompany } from "@/api/services/admin/company";
import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { dayjs } from "@/utils/dayjs";
import { formatNumber } from "@/utils/number";
import { Grid, Stack, Typography } from "@mui/material";

export const CompanySummary = () => {
  const { data: companyResult, isLoading: isLoadingCompany } = useCompany();

  const companyData = companyResult?.data;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Stack gap={2}>
          <InnerBox title={<Typography variant="sub16Bold">企業情報</Typography>} loading={isLoadingCompany}>
            <Typography whiteSpace="pre-line">{companyData?.companyDescription || "----"}</Typography>
          </InnerBox>
          <InnerBox title={<Typography variant="sub16Bold">備考欄（フリーテキスト）</Typography>} loading={isLoadingCompany}>
            <Typography whiteSpace="pre-line">{companyData?.note || "----"}</Typography>
          </InnerBox>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <InnerBox loading={isLoadingCompany} height="100%" justifyContent="center">
          <Stack gap={3}>
            <Stack direction="row" height="100%" gap={4} justifyContent="center" alignItems="center">
              <Stack gap={1}>
                <Typography variant="sub16Semi">当月1日時点での課金人数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {companyData?.totalFirstDayEnabledBillings || 0}人
                </Typography>
              </Stack>
              <Stack gap={1}>
                <Typography variant="sub16Semi">現時点の課金人数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {companyData?.totalCurrentEnabledBillings || 0}人
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="row" height="100%" gap={4} justifyContent="center" alignItems="start">
              <Stack gap={1}>
                <Typography variant="sub16Semi">最大課金対象数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {companyData?.currentMonthMaxBillableEmployeeCount ?? EMPTY_STR.TEXT}人
                </Typography>
                <Typography fontSize={12} color="text.secondary" textAlign="center">
                  {companyData?.currentMonthMaxBillableEmployeeCountDate
                    ? dayjs(companyData?.currentMonthMaxBillableEmployeeCountDate).format(DATE_FORMAT)
                    : EMPTY_STR.DATE}
                </Typography>
              </Stack>
              <Stack gap={1}>
                <Typography variant="sub16Semi">前回課金対象数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {companyData?.previousMonthMaxBillableEmployeeCount ?? EMPTY_STR.TEXT}人
                </Typography>
                <Typography fontSize={12} color="text.secondary" textAlign="center">
                  {companyData?.previousMonthMaxBillableEmployeeCountDate
                    ? dayjs(companyData?.previousMonthMaxBillableEmployeeCountDate).format(DATE_FORMAT)
                    : EMPTY_STR.DATE}
                </Typography>
              </Stack>
            </Stack>
            <Stack gap={1} alignItems="center">
              <Typography variant="sub16Semi">単価設定</Typography>
              <Typography variant="sub16Semi">
                {companyData?.pricePerEmployee ? `${formatNumber(companyData.pricePerEmployee)}円/人` : EMPTY_STR.TEXT}
              </Typography>
            </Stack>
          </Stack>
        </InnerBox>
      </Grid>
    </Grid>
  );
};
